document.addEventListener('bundler:bundle_widget_created', function(e) {
  console.log('DEBUG: Bundle loaded', e.detail.products);
});

$(document).ready(function () { 
  var trigger1_faceCondition = 0;
  var trigger2_eyeConcern = 0; 
  var trigger3_skinGoal = 0;
  var tried = 0; // 0 = Customer ("Yes"), 1 = Prospect ("No")
  var current_question = 0;
  var chosen;
  var score = Math.floor(Math.random() * 11) + 70; // Random score between 70-80
  var fname = "";
  var answers = [];
  var isTransitioning = false;
  var introduction_html = $(".introduction").html();

  // Product mapping using product IDs
  var q4_faceConditionCleanserIds = {
    0: ["2016495599686"],  // Dry or parched: Down to Earth
    1: ["2016495599686"],  // Same as when you woke up: Down to Earth
    2: ["14709559951723"], // Oily or shiny: Quality Control
  };

  var q5_eyeConcernProductIds = {
    0: ["6888107442279"],  // Fine lines: Wonderfill
    1: ["2016637681734"],  // Puffiness: All In
    2: ["14841599656299"], // Dark Circles: Tide & True
    3: ["14669128597867"], // Prevention: Retinol Eye Cream
  };

  var q6_skinGoalProductIds = {
    0: ["6914698281063", "2016512737350"], // Complexion/Discoloration: OCIN + Cloud Whip
    1: ["4480408027239", "7031474421863"], // Aging/wrinkles: Seeking C + Smooth Sailing
    2: ["2016630308934", "6657636302951"], // Daily Skincare: Pep Rally + Up the Anti
    3: ["6914698281063", "2016461226054"], // Acne/oily: OCIN + Daydreamer
    4: ["4480408027239", "6657636302951"], // Redness/rosacea: Seeking C + Up the Anti
    5: ["2016630308934", "2016624705606"], // Sensitive: Pep Rally + Night Shift
  };

  var questions = [
    {
      question: "What is your age?",
      options: [
        { option: "18 – 25", value: 0 },
        { option: "26 – 35", value: -2 },
        { option: "35 – 45", value: -5 },
        { option: "45 – 60", value: -8 },
        { option: "60+", value: -10 }
      ]
    },
    {
      question: "How many hours of sleep do you get a night?",
      options: [
        { option: "1 - 4", value: -5 },
        { option: "5 - 6", value: 0 },
        { option: "7+", value: 1 }
      ]
    },
    {
      question: "How many glasses of water do you drink daily?",
      options: [
        { option: "1 - 3", value: -4 },
        { option: "4 - 5", value: 1 },
        { option: "6 - 7", value: 3 },
        { option: "8+", value: 5 }
      ]
    },
    {
      question: "At the end of the day, does your face look:",
      options: [
        { option: "Dry or parched", value: 0 },
        { option: "Same as when you woke up", value: 0 },
        { option: "Oily or shiny", value: 0 }
      ]
    },
    {
      question: "What are your main eye area concerns?",
      options: [
        { option: "Fine lines", value: 0 },
        { option: "Puffy", value: 0 },
        { option: "Dark Circles", value: 0 },
        { option: "Prevention", value: 0 }
      ]
    },
    {
      question: "What about your skin would you most like to improve?",
      options: [
        { option: "Complexion/Discoloration", value: 0 },
        { option: "Aging/wrinkles", value: 1 },
        { option: "Daily Skincare routine", value: 2 },
        { option: "Acne/oily skin", value: 3 },
        { option: "Redness/rosacea", value: 4 },
        { option: "Sensitive skin", value: 5 }
      ]
    },
    {
      question: "Have you tried Eight Saints Skincare?",
      options: [
        { option: "Yes", value: 0 },
        { option: "No", value: 0 }
      ]
    }
  ];

  function logDebugInfo() {
    var trigger1Answer = questions[3].options[trigger1_faceCondition]?.option || 'N/A';
    var trigger2Answer = questions[4].options[trigger2_eyeConcern]?.option || 'N/A';
    var trigger3Answer = questions[5].options[trigger3_skinGoal]?.option || 'N/A';

    var trigger1ProductId = q4_faceConditionCleanserIds[trigger1_faceCondition] || [];
    var trigger2ProductId = q5_eyeConcernProductIds[trigger2_eyeConcern] || [];
    var trigger3ProductIds = q6_skinGoalProductIds[trigger3_skinGoal] || [];

    var mapProducts = function(idList) {
      return idList.map(function(id) {
        var productTitle = $(`.results-product[data-product-id="${id}"]`)
          .find('.card__information a.full-unstyled-link:first')
          .text()
          .trim();
        return (productTitle || 'Product') + ` | ID ${id}`;
      });
    };

    console.log("%cQUIZ DEBUG MODE", "color: #fbbf24; font-weight: bold;");
    console.log("Trigger 1 (Cleanser):", trigger1Answer, mapProducts(trigger1ProductId));
    console.log("Trigger 2 (Eye Cream):", trigger2Answer, mapProducts(trigger2ProductId));
    console.log("Trigger 3 (Main):", trigger3Answer, mapProducts(trigger3ProductIds));
  }

  // Handle URL reset/retake
  var urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('retake') === '1') {
    Cookies.remove("score");
    Cookies.remove("fname");
    Cookies.remove("trigger1_faceCondition");
    Cookies.remove("tried");
    Cookies.remove("trigger3_skinGoal");
    Cookies.remove("trigger2_eyeConcern");
    Cookies.remove("taken");
    window.location.href = window.location.pathname;
    return;
  }

  if (Cookies.get("score")) {
    score = Math.floor(Cookies.get("score"));
    fname = Cookies.get("fname") || "";
    trigger1_faceCondition = Number(Cookies.get("trigger1_faceCondition")) || 0;
    trigger2_eyeConcern = Number(Cookies.get("trigger2_eyeConcern")) || 0;
    trigger3_skinGoal = Number(Cookies.get("trigger3_skinGoal")) || 0;
    tried = Number(Cookies.get("tried")) || 0;
    showResults();
    $(".results").show();
    $(".question, .introduction").hide();
  } else {
    $(".skin-quiz").addClass("started");
    answers = [];
    $(".back").hide();
    var question = questions[current_question];
    $(".question").not(".email").show();
    $(".question h2").text(question.question);
    loadQuestions(question);
  }

  $(".retake").click(function (e) {
    e.preventDefault();
    Cookies.remove("score");
    Cookies.remove("fname");
    Cookies.remove("trigger1_faceCondition");
    Cookies.remove("tried");
    Cookies.remove("trigger3_skinGoal");
    Cookies.remove("trigger2_eyeConcern");
    
    score = Math.floor(Math.random() * 11) + 70;
    answers = [];
    current_question = 0;

    $(".introduction").after('<div class="introduction">' + introduction_html + "</div>");
    $(".introduction").first().remove();
    $("html, body").animate({ scrollTop: 1 }, 200);
    
    $(".results").hide();
    $(".options").empty();
    
    var question = questions[current_question];
    $(".question").not(".email").show();
    $(".question h2").text(question.question);
    loadQuestions(question);
  });

  $(".back").click(function () {
    if (current_question <= 0 || isTransitioning) return;
    
    current_question--;
    if (current_question === 0) {
      $(".back").hide();
    }
    
    var prevChosen = answers.pop();
    if (prevChosen !== undefined) {
      score -= questions[current_question].options[prevChosen].value;
    }

    var question = questions[current_question];
    $(".question h2").text(question.question);
    $(".options").empty();
    loadQuestions(question);
  });

  function showProducts(products) {
    if (!Array.isArray(products)) return;
    products.forEach(function(productId) {
      $(`.results-product[data-product-id="${productId}"]`).show();
    });
  }

  function removeQuizAdInputsIfTried() {
    if (Number(tried) === 0) {
      $('.quiz_result_ad_control').remove();
    }
  }

  function showResults() {
    Cookies.set("taken", 1);
    removeQuizAdInputsIfTried();

    $(".results .results-product").hide();
    showProducts(q4_faceConditionCleanserIds[trigger1_faceCondition]);
    showProducts(q5_eyeConcernProductIds[trigger2_eyeConcern]);
    showProducts(q6_skinGoalProductIds[trigger3_skinGoal]);

    document.querySelectorAll('.score').forEach(el => el.textContent = `Your score is ${score} out of 100.`);

    if (Number(tried) === 0) {
      $(".results-hero").show();
      $(".results-hero-discovery").hide();
      $(".results .products").show();
      $(".results .discovery_container").hide();
    } else {
      $(".results-hero").hide();
      $(".results-hero-discovery").show();
      $(".results .products").show();
      $(".inside_kit").hide(); 
      $(".bundle-banner-block").show();
      $(".results .discovery_container").show();
    }
  }

  function loadQuestions(question) {
    $(".step-counter").text("Step " + (current_question + 1) + " of " + questions.length);
    $(".options").empty();

    for (var j = 0; j < question.options.length; j++) {
      var optionId = "q_" + current_question + "_opt_" + j;
      if (question.options[j].option !== "") {
        $(".options").append(
          "<div class='option'>" +
            "<input type='radio' id='" + optionId + "' value='" + j + "' name='q_" + current_question + "' />" +
            "<label for='" + optionId + "'>" + question.options[j].option + "</label>" +
          "</div>"
        );
      }
    }

    $("input[name='q_" + current_question + "']").off('change').on('change', function () {
      if (isTransitioning) return;
      isTransitioning = true;

      $(this).parent().find("label").addClass("selected");
      chosen = parseInt($(this).val(), 10);

      setTimeout(function () {
        answers.push(chosen);
        $(".back").show();

        if (current_question === 3) {
          trigger1_faceCondition = chosen;
        } else if (current_question === 4) {
          trigger2_eyeConcern = chosen;
        } else if (current_question === 5) {
          trigger3_skinGoal = chosen;
        } else if (current_question === 6) {
          tried = chosen;
        }

        score += questions[current_question].options[chosen].value;
        current_question++;

        if (current_question === questions.length) {
          $(".question, .introduction").hide();
          if (Cookies.get("taken") !== "1") {
            $(".email h2").text("What is your name and email address?");
            $(".email").show();
          } else {
            $(".results").show();
            showResults();
          }
        } else {
          var nextQuestion = questions[current_question];
          $(".question h2").text(nextQuestion.question);
          loadQuestions(nextQuestion);
        }

        isTransitioning = false;
      }, 400);
    });
  }

  // Bind email form submit once globally
  $(".email form").off("submit").on("submit", function (e) {
    var emailVal = $("#k_id_email").val() || "";
    var nameVal = $("#k_id_firstname").val() || "";
    var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!nameVal.trim() || !emailRegex.test(emailVal.trim())) {
      return; 
    }

    $("html, body").animate({ scrollTop: 1 }, 200);
    $(".email").hide();
    $(".results").show();

    Cookies.set("fname", nameVal);
    Cookies.set("tried", tried);
    Cookies.set("score", score);
    Cookies.set("trigger3_skinGoal", trigger3_skinGoal);
    Cookies.set("trigger2_eyeConcern", trigger2_eyeConcern);
    Cookies.set("trigger1_faceCondition", trigger1_faceCondition);

    showResults();
  });
});